export * from '@src/app/_redux/root-action';
export * from '@src/app/_redux/root-reducer';
export * from '@src/app/_redux/root-epic';
export * from '@src/app/_redux/types';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/_redux/index.ts